package com.macrofocus.eflux.network

import web.cssom.ClassName
import web.dom.DOMTokenList

/**
 * Sets a given class name if the value is false
 */
class StringClassname(private val tokens: DOMTokenList<ClassName>?, initialValue: ClassName? = null) {
    var value: ClassName? = initialValue
        set(value) {
            if(field != value) {
                if(field != null && field != ClassName("")) {
                    tokens?.remove(field!!)
                }
                if(value != null && value != ClassName("")) {
                    tokens?.add(value)
                }
                field = value
            }
        }
}